import '../styles/chunks/app.blog.styl';
import { dispatch, getState } from 'services/store';
import { COOKIES } from 'constants/constants';
import CookiesBanner from 'atoms/cookie-banner';
import { store as globalStore } from 'app/boot/init';
import { ID_ROUTES } from 'constants/routes';
import ModalContainer from 'components/modal/new-modal/modal-container';
import NotificationsBannerController from 'components/search/NotificationsBannerController';
import PopunderController from 'components/ads/popunder-controller';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import React from 'react';
import { render } from 'react-dom';
import { requestSuggestionBox } from 'actions/adActions';
import SearchBarContainer from 'molecules/search-bar/container';
import { setContext } from 'services/context';
import SuggestionBox from 'molecules/suggestion-box/container';
import { t } from 'services/Intl';
import { trackPageView } from 'services/tracking';


function App(props) {
  trackPageView();
  const { store, destination } = props;
  return (
    <Provider store={ store }>
      <span>
        <SearchBarContainer
          className="landing-page__search-bar"
          destination={ destination }
          isLandingSeo={ true }
          route={ ID_ROUTES.BLOG }
        />
        <SuggestionBox
          adLogo="https://static.100r.systems/img/inline-ads/airbnb_logo.png"
          className="landing-page__suggestion-box"
          t={ t }
          underComponent="search-bar-molecule"
        />
        <ModalContainer />
        <PopunderController />
        <NotificationsBannerController />
      </span>
    </Provider>
  );
}

App.defaultProps = {
  destination: '',
};

App.propTypes = {
  destination: PropTypes.string,
  store: PropTypes.shape().isRequired,
};

const AppIntl = setContext(App, global.hr.intl, global.isPhone, global.isTablet);
render(<AppIntl store={ globalStore } />, document.querySelector('#search-bar'));

const currentState = getState();
const search = Object.assign({}, currentState.destination, currentState.searchFormReducer);
dispatch(requestSuggestionBox(search));

const cookiesBanner = document.querySelector('#cookies-banner');
const literal = t('This site uses first and third party cookies to help you provide you with the best experience that we can. By continuing to browse Hundredrooms, you are agreeing to our use of cookies.');
if (cookiesBanner) {
  render(<CookiesBanner
    cookieName={ COOKIES.COOKIES_BANNER }
    dispatch={ dispatch }
    literal={ literal }
  />, cookiesBanner);
}

global.history.pushState = function (state, title, url) {
  global.location.href = url;
};
